import { isMobileDevice } from "../../../commons/utils";
import { ConsultaPadrao } from "../../../components/ConsultaPadrao";
import { model_colaborador_classificacao } from "../../../models";
import { DynamicIcon } from 'lucide-react/dynamic';

export const ColaboradorClassificacao = () => {
    function drawColors(e: any) {
        return (
            <div style={{
                backgroundColor: e.colclasscor,
                maxWidth: isMobileDevice() ? '100%' : '32px',
                width: '100%',
                height: isMobileDevice() ? '3px' : '30px',
                borderRadius: '2px'
            }} />
        )
    }

    function drawIcon(e: any) {
        return (
            <DynamicIcon name={e.colclassicone} />
        )
    }

    const columns = [
        { field: 'colclassdescricao', header: 'Descrição' },
        { field: 'colclasscor', header: 'Cor', notSortable: true, body: (e: any) => drawColors(e) },
        { field: 'colclassativo', header: 'Ativo' },
        { field: 'colclassicone', header: 'Ícone', notSortable: true, body: (e: any) => drawIcon(e) },
        { field: 'functions', style: { minWidth: '2rem', width: '2rem' } }
    ];

    return (
        <ConsultaPadrao model={model_colaborador_classificacao} columns={columns} sortField="colclassdescricao" />
    )
}